document.addEventListener("turbo:load", () => {
  const input = document.getElementById("search-input");
  const button = document.getElementById("search-button");
  const resultsFrame = document.getElementById("search_results");
  const loading = document.getElementById("search-loading");

  if (!input || !button || !resultsFrame) return;

  let debounceTimer;

  const performSearch = () => {
    const query = input.value.trim();

    if (loading) loading.style.display = "block";
    
    // We only clear the innerHTML if we want to show loading state, but for a smoother live search
    // we can leave the old results visible while fetching, or we can add a loading overlay.
    // resultsFrame.innerHTML = "";

    fetch(`/cart/search_books?q=${encodeURIComponent(query)}`, {
      headers: { "Accept": "text/vnd.turbo-stream.html" }
    })
      .then(response => response.text())
      .then(html => {
        if (loading) loading.style.display = "none";
        resultsFrame.innerHTML = html;
        resultsFrame.style.display = "block";
      })
      .catch(err => {
        if (loading) loading.style.display = "none";
        console.error("Erro na busca:", err);
      });
  };

  button.addEventListener("click", performSearch);

  input.addEventListener("focus", () => {
    if (resultsFrame.innerHTML.trim() === "") {
      performSearch();
    } else {
      resultsFrame.style.display = "block";
    }
  });

  input.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      performSearch();
    }, 300);
  });
  
  // Fechar o dropdown ao clicar fora
  document.addEventListener("click", (e) => {
    if (!input.contains(e.target) && !resultsFrame.contains(e.target) && !button.contains(e.target)) {
      resultsFrame.style.display = "none";
    }
  });
});
